export const handleChangeDataPageAboutUs = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_ABOUT_US', name, value
});